import React from 'react';
import { Modal, Button, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import s from './s.module.less';
import { TPaymentBilling } from 'types/provider';
import { cancelInvoice } from 'api/provider';

interface CancelInvoiceModalProps {
    open: boolean;
    onCancel: () => void;
    item: TPaymentBilling;
    onSuccess?: () => void;
}

const CancelInvoiceModal: React.FC<CancelInvoiceModalProps> = ({
    open,
    onCancel,
    item,
    onSuccess,
}) => {
    const [loading, setLoading] = React.useState(false);
    const handleInvoiceCancel = async () => {
        setLoading(true);
        try {
            const res = await cancelInvoice(item.invoiceNo!);
            if (!res.error) {
                message.success('Invoice cancelled successfully');
                onSuccess?.();
                onCancel();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            width={512}
            centered
            className={s.cancelInvoiceModal}
            closeIcon={<CloseOutlined className={s.closeIcon} />}
        >
            <div className={s.modalContent}>
                <div className={s.modalHeader}>
                    <div className={s.warningIconWrapper}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12.0015 9V11M12.0015 15H12.0115M5.0733 19H18.9297C20.4693 19 21.4316 17.3333 20.6618 16L13.7336 4C12.9637 2.66667 11.0392 2.66667 10.2694 4L3.34125 16C2.57145 17.3333 3.5337 19 5.0733 19Z" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div className={s.modalTitle}>Cancel invoice?</div>
                </div>
                <div className={s.modalDescription}>
                    Are you sure you want to cancel this invoice? Once cancelled, the patient will be notified and this invoice can no longer be paid.
                </div>
                <div className={s.modalFooter}>
                    <Button
                        onClick={onCancel}
                        className={s.keepInvoiceButton}
                        disabled={loading}
                    >
                        Keep invoice
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={handleInvoiceCancel}
                        className={s.cancelInvoiceButton}
                        loading={loading}
                    >
                        Cancel invoice
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CancelInvoiceModal;
